import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Stack, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';
import { IJob } from 'wisestep-api';
import {
  WsButton,
  WsIconEmail,
  WsIconFaceBook,
  WsIconTwitter,
  WsIconWhatsApp,
  WsTypoColors,
  WsTypography,
} from 'wisestep-base';

import { ActivateFeature } from '../../../../../components/ActivateFeature';
import { copyStringToClipboard } from '../../../../../features/jobs/listing/components/jobCardRightChild/JobCardRightChild';
import { careerPageSettingStore } from '../../../../../utils/careerPageSettingsStore';
import { success } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import socialMediaShareUrl, { indexJob } from '../../../../../utils/shareUrl';
import PostOnJobTarget from '../jobTarget/PostOnJobTarget';

export interface ShareJobBoardsProps {
  shareUrl: string;
  title: string;
  emailSubject?: string;
  emailBody?: string;
  iconSize?: number;
  page?: string;
  job: IJob;
}

const PostOnSocialMedia: React.FC<ShareJobBoardsProps> = ({
  shareUrl,
  title,
  job,
}: ShareJobBoardsProps) => {
  const careerPageSetting = careerPageSettingStore((state) => state.careerPageSettings);
  const indexJobToCareerPage = async () => indexJob(job, careerPageSetting);
  const setNotification = useNotificationStore((state) => state.setNotification);

  let domain = '';
  if (job) {
    domain = socialMediaShareUrl(job, careerPageSetting);
  }

  const navigate = useNavigate();
  const navigateToAddAccount = () => navigate(`/jobs`);

  const handleClipBoard = (data: string) => {
    copyStringToClipboard(data);
    setNotification(success('Copied Successfully !!'));
  };

  return (
    <Grid>
      <PostOnJobTarget job={job} />
      <ActivateFeature feature="JS_SOCIAL_SHARING_OF_JOBS">
        <Paper variant="outlined" sx={{ mt: 3 }}>
          <Grid p={3}>
            <WsTypography color={WsTypoColors.SECONDARY}>Social Media</WsTypography>
            <Stack spacing={6} direction="row" alignContent="center" p={2}>
              <FacebookShareButton
                beforeOnClick={indexJobToCareerPage}
                quote={title}
                url={`${domain}?utm_source=facebook`}
              >
                <WsIconFaceBook />
              </FacebookShareButton>
              <WhatsappShareButton url={`${domain}?utm_source=whatsapp`}>
                <WsIconWhatsApp />
              </WhatsappShareButton>
              <TwitterShareButton url={`${domain}?utm_source=twitter`}>
                <WsIconTwitter />
              </TwitterShareButton>
              <EmailShareButton
                url={`${shareUrl}?utm_source=email`}
                subject={'subject'}
                body={domain}
              >
                <WsIconEmail />
              </EmailShareButton>
              <ContentCopyIcon
                color="primary"
                fontSize="medium"
                sx={{
                  cursor: 'pointer',
                }}
                onClick={() => handleClipBoard(shareUrl)}
              />
            </Stack>
          </Grid>
        </Paper>
        <Grid item container xs={12} pt={3} justifyContent="flex-end">
          <WsButton size="large" onClick={navigateToAddAccount} endIcon={<CheckIcon />}>
            Complete
          </WsButton>
        </Grid>
      </ActivateFeature>
    </Grid>
  );
};

export default PostOnSocialMedia;
